import { css } from '@emotion/css';
import times from 'lodash/times';

const MAX_ROW_DEPTH = 20;
const ICON_BUTTON_SIZE = 2.4;

/**
 * This class is used to decrease the width of a cell that is inside a nested row.
 * This ensures all columns after this cell are aligned properly.
 */
export const NESTING_WIDTH_ADJUSTMENT_CLASSNAME = 'nesting-width-adjustment';

export const getEmptyChildrenRowCellPadding = ({
  expandColumnKeyIndex = 0,
}: {
  expandColumnKeyIndex?: number;
}) => css`
  .BaseTable__row-cell:nth-child(${expandColumnKeyIndex + 1}) > a,
  .BaseTable__row-cell:nth-child(${expandColumnKeyIndex + 1}) > div {
    padding-inline-start: 3.2rem !important;
  }
`;

export const getNestedTableDepthStyles = ({
  paddingLeft = 1.5,
  expandColumnKeyIndex = 0,
  useMargin = false,
}: {
  paddingLeft?: number;
  expandColumnKeyIndex?: number;
  useMargin?: boolean;
}) => css`
  ${times(MAX_ROW_DEPTH, (index) => {
    const depth = index + 1;
    const offset = paddingLeft + ICON_BUTTON_SIZE * depth;
    return `
      .BaseTable__row--depth-${depth} .BaseTable__row-cell:nth-child(${expandColumnKeyIndex + 1}) {
        ${useMargin ? 'margin-inline-start' : 'padding-inline-start'}: ${offset}rem;
      }
      .BaseTable__row--depth-${depth} .BaseTable__row-cell.${NESTING_WIDTH_ADJUSTMENT_CLASSNAME} {
        padding-inline-end: ${offset}rem;
        margin-inline-end: -${offset}rem;
      }
      .BaseTable__row--depth-${depth} > .flex > .w-full > .flex > .task-list-item > .BaseTable__row-cell > .edit-bar-container > .edit-bar {
        margin-inline-end: ${2.2 * depth}rem !important;
      }
    `;
  })}
`;

export const reportTableStyles = css`
  box-shadow: none;

  .BaseTable__table,
  .BaseTable__table-main,
  .BaseTable__header,
  .BaseTable__row,
  .BaseTable__footer,
  .BaseTable__body {
    background-color: var(--bg-primary);
  }

  .BaseTable__header {
    background-color: var(--bg-primary);
    border-bottom: 1px solid var(--border);

    .BaseTable__header-row {
      background-color: transparent;
      border-bottom: none;
    }
  }

  .BaseTable__row {
    border-bottom: none;

    &:hover,
    &.BaseTable__row--hovered {
      background-color: transparent;
    }
  }

  .BaseTable__row:not(:last-child) {
    border-bottom: 1px solid var(--border);
  }

  .BaseTable__column-resizer {
    width: 2px;
    background-color: var(--interactive-primary);
  }
`;
